import { AppProvider } from './components/ui/AppProvider'
import { EncounterSessionProvider } from './context/encounterSessionContext'
import {
  HospitalListLoader,
  HospitalProvider,
} from './context/hospitalContext'
import { HomePage } from './pages/HomePage'
import './index.css'

/**
 * TCM wizard (step 1 = Patient Lookup) embedded in RM, with TCM Chakra v3 theme.
 */
export function TcmModuleEntry() {
  return (
    <AppProvider>
      <EncounterSessionProvider>
        <HospitalProvider>
          <HospitalListLoader />
          <HomePage embedded />
        </HospitalProvider>
      </EncounterSessionProvider>
    </AppProvider>
  )
}

/** TCM wizard entry via direct patient URL — skips Step 1 by resolving the patient from Athena IDs. */
export function TcmDirectEntry({
  tablespace,
  athenaPatientId,
  dischargeDate,
}: {
  tablespace: string
  athenaPatientId: string
  dischargeDate: string
}) {
  return (
    <AppProvider>
      <EncounterSessionProvider>
        <HospitalProvider>
          <HospitalListLoader />
          <HomePage
            embedded
            directEntry={{ tablespace, athenaPatientId, dischargeDate }}
          />
        </HospitalProvider>
      </EncounterSessionProvider>
    </AppProvider>
  )
}
